/* eslint-disable react/prop-types */
import BackPillButton from './BackPillButton'

export default function MemberMobileBookingHeader({
  eyebrow,
  desktopEyebrow,
  title,
  desktopTitle,
  backLabel,
  backTo,
  backState,
  onBack,
  secondaryAction,
  secondaryBeforeBack = false,
  meta,
  className = '',
}) {
  const backControl = (
    <BackPillButton
      className="mp-mobile-booking-header__back"
      to={backTo}
      state={backState}
      onClick={onBack}
    >
      <span className="mp-mobile-booking-header__back-label">{backLabel}</span>
    </BackPillButton>
  )

  return (
    <div className={`mp-mobile-booking-header ${className}`.trim()}>
      <div className="mp-mobile-booking-header__heading">
        <p className={`mp-eyebrow${desktopEyebrow ? ' mp-mobile-booking-header__eyebrow--mobile' : ''}`}>{eyebrow}</p>
        {desktopEyebrow ? <p className="mp-eyebrow mp-mobile-booking-header__eyebrow--desktop">{desktopEyebrow}</p> : null}
        <h4 className="mp-panel__title">
          <span className={desktopTitle ? 'mp-mobile-booking-header__title--mobile' : ''}>{title}</span>
          {desktopTitle ? <span className="mp-mobile-booking-header__title--desktop">{desktopTitle}</span> : null}
        </h4>
        {meta}
      </div>
      <div className="mp-mobile-booking-header__actions">
        {secondaryBeforeBack ? secondaryAction : backControl}
        {secondaryBeforeBack ? backControl : secondaryAction}
      </div>
    </div>
  )
}
